const { url_images } = require("../../lib/backend/data")

const paymentData = {
    logos: {
        "transbank": `${url_images}/payments_methods/webpay.png`,
        "fintoc": `${url_images}/payments_methods/fintoc.svg`,
        "khipu": `${url_images}/payments_methods/khipu.webp`
    },
    descripciones: {
        "transbank": "Pago con tarjetas de crédito y débito",
        "fintoc": "Pago con transferencia bancaria segura",
        "khipu": "Pago con transferencia bancaria segura",
        "transferencia": "Pago con transferencia bancaria"
    }
}

module.exports = paymentData